/******************************************
 *  Author : Suraj Sharma
 *  Created On : Mon Dec 21 2020
 *  File : Images.js
 *******************************************/
const Images = {
    markerNormal : '/images/normal_large.png',
    markerNormalAnim : '/images/normal_anim_large.png',
    markerSelected : '/images/selected_large.png',
    markerSelectedAnim : '/images/selected_anim_large.png',
    avatarPlaceHolder: '/images/menu-2.png',
    loader: '/images/loader.gif'
}

export default Images;